type PosthogShim = { reset?: (clear: boolean) => void };
type PosthogUtilsShim = { resetForUserSwitch?: (clear: boolean) => void };

/** Reset PostHog identity on impersonate/unimpersonate so events attribute correctly. */
export const resetPostHog = (): void => {
	const utils = (window as unknown as { posthogUtils?: PosthogUtilsShim }).posthogUtils;
	const ph = (window as unknown as { posthog?: PosthogShim }).posthog;
	if (utils?.resetForUserSwitch) {
		utils.resetForUserSwitch(true);
		return;
	}
	ph?.reset?.(true);
};
